import React from "react";
import { FaWhatsapp, FaClock } from "react-icons/fa";

export default function WhatsAppAlertsPage() {
  return (
    <div className="p-4 max-w-[1400px] mx-auto min-h-[80vh] flex flex-col justify-center items-center font-sans text-gray-800 dark:text-slate-100 transition-colors duration-300">
      <div className="bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-800 rounded-3xl p-8 sm:p-12 text-center max-w-lg w-full shadow-lg">
        {/* WhatsApp Icon */}
        <div className="w-16 h-16 bg-emerald-100 dark:bg-emerald-950/60 text-emerald-600 dark:text-emerald-400 rounded-2xl flex items-center justify-center mx-auto mb-5 shadow-xs border border-emerald-200 dark:border-emerald-800">
          <FaWhatsapp size={36} />
        </div>

        {/* Status Badge */}
        <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-emerald-50 dark:bg-emerald-950 text-emerald-600 dark:text-emerald-400 text-xs font-black uppercase tracking-wider mb-4 border border-emerald-200 dark:border-emerald-800">
          <FaClock size={11} /> Coming Soon
        </div>

        {/* Title */}
        <h1 className="text-2xl sm:text-3xl font-black text-gray-900 dark:text-white tracking-tight mb-2">
          WhatsApp Alerts
        </h1>

        {/* Description */}
        <p className="text-xs sm:text-sm text-gray-500 dark:text-slate-400 font-semibold leading-relaxed mb-6">
          Automated WhatsApp notifications for fee due reminders, student attendance alerts, and official announcements are under development.
        </p>

        {/* Simple Status Box */}
        <div className="bg-gray-50 dark:bg-slate-800/60 border border-gray-200 dark:border-slate-700/60 rounded-2xl p-4 text-xs font-bold text-gray-600 dark:text-slate-300">
          Official WhatsApp Business API integration in progress
        </div>
      </div>
    </div>
  );
}
